import React from 'react';
import PropTypes from 'prop-types';

import starsYellowIcon from 'assets/images/stars-yellow.svg';

const ReviewsLink = ({ href }) => (
  <span href={href} className="reviews-link">
    <img className="reviews-link__stars" src={starsYellowIcon} alt="Review Stars" />
    <span className="reviews-link__text">Customer Rating</span>
  </span>
);

ReviewsLink.propTypes = {
  href: PropTypes.string.isRequired,
};

export default ReviewsLink;



// WEBPACK FOOTER //
// ./src/components/ReviewsLink.js